import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class CourtAccountModel extends BaseModel {

    constructor() {
        super({ 
                name: "court_account",
                tableName: 'users', 
                label: "Danh sách tài khoản tòa",
                display_key: 'fullname', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                display: false
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            code : { 
                name: 'code', 
                type: "String", 
                label: 'Mã nhân viên (Tên đăng nhập)', 
                sortable: false,
                width : 10,
                class: "center",
                filter: { type: 'input', match: 'contains', placeHolder: 'Nhập mã NV'},
            },
            avatar: {
                name: 'avatar', 
                type: "Image",
                label: 'Avatar',
                // inputOptions: { mode: 'multiple' },  
                display: false,
                accessable: "image/*"
            },
            
            fullname: {
                name: 'fullname', 
                type: "String",
                label: 'Tên nhân viên',
                width : 15,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            email: {
                name: 'email',
                type: "String",
                label: 'Email',
                width : 15,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            str_code_agency: {
                name: 'str_code_agency',
                type: "String",
                label: 'Mã tòa',
                width : 15,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            /*phone : {
                name: 'phone', 
                type: "String", 
                label: 'Số điện thoại', 
                sortable: false,
                width : 10,
                class: "center",
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
            },*/
            /*group_permissions: {
                refs: 'group_permissions {id name}',
                display: false
            },
            display_group_permissions: {
                name: 'display_group_permissions', 
                label: 'Nhóm quyền',
                class: "center",
                width: 20,
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_group_permissions = '';
                    if(data.group_permissions !== undefined && data.group_permissions !== null){
                        data.display_group_permissions = data.group_permissions.name;
                    }
                }
            },*/
            /*areas: {
                refs: 'areas {id code}',
                display: false
            },*/
            /*display_areas: {
                name: 'display_areas', 
                label: 'Mã khu vực quản lý',
                class: "center",
                width: 9,
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_areas = '';
                    if(data.areas !== undefined && data.areas !== null){
                        data.display_areas = data.areas.code;
                    }
                }
            },*/
            active: {
                name: 'active', 
                type: "Boolean",
                label: 'Trạng thái',
                // filter: { type: 'input', match: 'contains'},
                display: false
            },
            display_active: {
                name: 'display_active', 
                label: 'Trạng thái',
                class: "center",
                width: 7,
                computed: (data) => {
                    data.display_active = '<div style="text-align: center;"><i class="pi pi-times"></i></div>';
                    if(data.active == true){
                        data.display_active = '<div style="text-align: center;"><i class="pi pi-check"></i></div>';
                    }
                }    
            },
            key_get1: {
                refs:  'str_code_agency',
                display: false
            },
        },)
    }

}